var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filter-invoices',{ref:"FilterInvoices"}),_c('show-invoices',{ref:"ShowInvoices"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }